import React, { useEffect, useState } from 'react';
import { X, Download, Smartphone } from 'lucide-react';
import { Button } from './ui/button';

const INSTALL_DISMISSED_KEY = 'fpn_pwa_dismissed';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Already installed -> hide
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
      return;
    }
    // Recently dismissed -> hide (re-show after 7 days)
    const dismissedAt = parseInt(localStorage.getItem(INSTALL_DISMISSED_KEY) || '0', 10);
    if (dismissedAt && Date.now() - dismissedAt < 7 * 24 * 60 * 60 * 1000) return;

    // iOS detection (Safari doesn't fire beforeinstallprompt)
    const ua = window.navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    if (iOS) {
      setIsIOS(true);
      // delay so it doesn't feel intrusive
      const t = setTimeout(() => setShow(true), 8000);
      return () => clearTimeout(t);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShow(true), 4000);
    };
    window.addEventListener('beforeinstallprompt', handler);

    const installed = () => setShow(false);
    window.addEventListener('appinstalled', installed);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', installed);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(INSTALL_DISMISSED_KEY, Date.now().toString());
    setShow(false);
  };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShow(false);
    setDeferredPrompt(null);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-96 z-[60] bg-[#0a0a0a] text-white rounded-2xl shadow-2xl border border-neutral-800 p-4 animate-in slide-in-from-bottom">
      <button onClick={dismiss} className="absolute top-3 right-3 text-neutral-400 hover:text-white" aria-label="Dismiss">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3 pr-6">
        <div className="w-11 h-11 bg-[#bfff00] rounded-xl flex items-center justify-center shrink-0">
          <Smartphone className="w-5 h-5 text-black" />
        </div>
        <div className="flex-1">
          <p className="font-black text-sm">Install Fitness Pro Nutrition</p>
          {isIOS ? (
            <p className="text-xs text-neutral-300 mt-1 leading-relaxed">
              Tap the <span className="font-bold">Share</span> button in Safari and select <span className="font-bold">&ldquo;Add to Home Screen&rdquo;</span> for the best experience.
            </p>
          ) : (
            <p className="text-xs text-neutral-300 mt-1">
              Get faster checkout, exclusive offers, and quick access from your home screen.
            </p>
          )}
          {!isIOS && (
            <Button onClick={install} className="mt-3 bg-[#bfff00] hover:bg-[#a8e600] text-black font-bold h-9 px-4">
              <Download className="w-4 h-4 mr-1" /> Install App
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
